<template>
    <div class="description" :class="dark ? 'description--dark' : 'description--light'">
        <p class="description__text">
            {{ trimmedDescription }}
            <a
                v-if="description && description.length > 400"
                class="description__read-more text-primary cursor-pointer"
                @click="readMore = !readMore"
            >
                {{ $t('entityHeader.readMore') }}
            </a>
        </p>
        <AonModal v-if="readMore" :title="title" @close="cancelDescriptionDialog()">
            <p
                v-for="(section, i) in description.split(/\\n/g)"
                :key="`description_${i}`"
                class="description__section mb-sm"
            >
                {{ section }}
            </p>
        </AonModal>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: null,
    },
    description: {
        type: String,
        default: null,
    },
    dark: {
        type: Boolean,
        default: true,
    },
})

const readMore = ref(false)

const trimmedDescription = computed(() => {
    if (!props.description) {
        return ''
    }
    if (props.description.length > 500) {
        return `${props.description.slice(0, 500).replace(/\\n/g, ' ').trimEnd()}...`
    } else {
        return `${props.description.slice(0, 500).replace(/\\n/g, ' ').trimEnd()}`
    }
})

const cancelDescriptionDialog = () => {
    readMore.value = false
}
</script>

<style lang="scss" scoped>
.description {
    width: 100%;

    &__text {
        line-height: 1.5rem;
        font-size: var(--font-size-base);
    }

    &__read-more {
        color: var(--color-primary);
        font-weight: var(--font-weight-medium);
    }

    &__section {
        margin-bottom: var(--spacing-sm);
        line-height: 1.5rem;
    }

    &--dark {
        .description__text {
            color: var(--color-text-on-dark);
        }
    }

    &--light {
        .description__text {
            color: var(--color-text-primary);
        }
    }
}
</style>
